"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const accordionInputs = [
  {
    name: "singleExpanded",
    type: "boolean",
  },
  {
    name: "trackingEventType",
    type: "string",
    defaultValue: "none",
    enum: ["none", "faq"],
  },
] as const satisfies Inputs;

export const AccordionComponent: RegisteredComponent = {
  name: "Accordion",
  component: withValidation(
    accordionInputs,
    dynamic(() => import("./Accordion").then((mod) => mod.Accordion)),
    "Accordion"
  ),
  canHaveChildren: true,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "AccordionItem",
        options: {
          title: "First Accordion Item",
          id: "accordion-item",
        },
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "AccordionItem",
        options: {
          title: "Second Accordion Item",
          id: "accordion-item-1",
        },
      },
    },
  ],
  childRequirements: {
    message: "You can only put AccordionItem component inside this component",
    query: {
      "component.name": {
        $in: ["AccordionItem"],
      },
    },
  },
  inputs: accordionInputs,
};
